import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {API_BASE_URL} from "./constants";

export const fetchHeaderTopText = createAsyncThunk(
    'data/fetchHeaderTopText',
    async () => {
        const currentLanguage = localStorage.getItem('i18nextLng');
        let transformedLocale;
        if (currentLanguage.startsWith('en')) {
            transformedLocale = 'en';
        } else if (currentLanguage.startsWith('fr')) {
            transformedLocale = 'fr';
        } else if (currentLanguage.startsWith('sv')) {
            transformedLocale = 'sv';
        } else if (currentLanguage.startsWith('fi')) {
            transformedLocale = 'fi';
        } else if (currentLanguage.startsWith('nl')) {
            transformedLocale = 'nl';
        } else if (currentLanguage.startsWith('dk') || currentLanguage.startsWith('da')) {
            transformedLocale = 'da';
        } else if (currentLanguage.startsWith('no')) {
            transformedLocale = 'nb';
        } else if (currentLanguage.startsWith('es')) {
            transformedLocale = 'es';
        }
        else {
            transformedLocale = currentLanguage ?? 'en';
        }
        const response = await fetch(`${API_BASE_URL}/header-top-text?locale=${transformedLocale}`);
        const data = await response.json();
        return data.data.attributes.Text;
    }
);

export const fetchHomePageFooterText = createAsyncThunk(
    'data/fetchHomePageFooterText',
    async () => {
        const currentLanguage = localStorage.getItem('i18nextLng') ?? 'en';
        let transformedLocale;
        if (currentLanguage.startsWith('en')) {
            transformedLocale = 'en';
        } else if (currentLanguage.startsWith('fr')) {
            transformedLocale = 'fr';
        } else if (currentLanguage.startsWith('sv')) {
            transformedLocale = 'sv';
        } else if (currentLanguage.startsWith('fi')) {
            transformedLocale = 'fi';
        } else if (currentLanguage.startsWith('nl')) {
            transformedLocale = 'nl';
        } else if (currentLanguage.startsWith('dk') || currentLanguage.startsWith('da')) {
            transformedLocale = 'da';
        } else if (currentLanguage.startsWith('no')) {
            transformedLocale = 'nb';
        } else if (currentLanguage.startsWith('es')) {
            transformedLocale = 'es';
        }
        else {
            transformedLocale = currentLanguage ?? 'en';
        }
        const response = await fetch(`${API_BASE_URL}/home-page-footer-text?locale=${transformedLocale}`);
        const data = await response.json();
        return data.data.attributes.Text;
    }
);

export const fetchHeroData = createAsyncThunk(
    'data/fetchHeroData',
    async () => {
        const currentLanguage = localStorage.getItem('i18nextLng') ?? 'en';
        let transformedLocale;
        if (currentLanguage.startsWith('en')) {
            transformedLocale = 'en';
        } else if (currentLanguage.startsWith('fr')) {
            transformedLocale = 'fr';
        } else if (currentLanguage.startsWith('sv')) {
            transformedLocale = 'sv';
        } else if (currentLanguage.startsWith('fi')) {
            transformedLocale = 'fi';
        } else if (currentLanguage.startsWith('nl')) {
            transformedLocale = 'nl';
        } else if (currentLanguage.startsWith('dk') || currentLanguage.startsWith('da')) {
            transformedLocale = 'da';
        } else if (currentLanguage.startsWith('no')) {
            transformedLocale = 'nb';
        } else if (currentLanguage.startsWith('es')) {
            transformedLocale = 'es';
        }
        else {
            transformedLocale = currentLanguage ?? 'en';
        }
        const response = await fetch(`${API_BASE_URL}/hero-sliders?locale=${transformedLocale}`);
        const data = await response.json();
        function moveAttributesToTopLevel(items) {
            return items.map(item => {
                const newItem = JSON.parse(JSON.stringify(item));
                const attributes = newItem.attributes;
                delete newItem.attributes;
                return { ...attributes, ...newItem, url: "/shop-grid-standard" };
            });
        }
        return moveAttributesToTopLevel(data.data);
    }
);


const dataSlice = createSlice({
    name: 'data',
    initialState: {
        headerTopText: '',
        homePageFooterText: '',
        heroData: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchHeaderTopText.fulfilled, (state, action) => {
            state.headerTopText = action.payload;
        });
        builder.addCase(fetchHomePageFooterText.fulfilled, (state, action) => {
            state.homePageFooterText = action.payload;
        });
        builder.addCase(fetchHeroData.fulfilled, (state, action) => {
            state.heroData = action.payload;
        });
    },
});

export default dataSlice.reducer;
